var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useEffectOnce } from 'react-use';
import { flowsApi } from 'apis/flows';
import { analytics } from 'app/utils/segment';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { EditModal } from '../editModal/editModal';
export const RenameModal = (props) => {
    const { mode, onClose } = props;
    const notify = useNotifications();
    const [readFlowsSchedule, { data: readFlowScheduleResponse }] = flowsApi.useLazyReadFlowScheduleQuery();
    const [updateSchedule, { isLoading }] = flowsApi.useUpdateFlowScheduleMutation();
    const isEditMode = mode === 'edit';
    useEffectOnce(() => {
        if (!isEditMode) {
            readFlowsSchedule({ id: props.schedule.id });
        }
    });
    const handleSubmit = useCallback(({ name }) => __awaiter(void 0, void 0, void 0, function* () {
        analytics.businessHoursRenameScheduleFormSubmitted({
            view: mode === 'edit' ? 'edit' : 'list',
        });
        if (isEditMode) {
            props.onSubmit(name);
            onClose();
            return;
        }
        const { schedule, refetchItems } = props;
        if (readFlowScheduleResponse) {
            const { announcement, auto_reply_template_id, country_code, version } = readFlowScheduleResponse;
            const payload = {
                auto_reply_template_id,
                announcement,
                country_code,
                name,
                timezone: schedule.timezone,
                version,
            };
            const res = yield updateSchedule({
                id: schedule.id,
                schedule: payload,
            });
            if ('data' in res) {
                notify({
                    title: 'Schedule renamed!',
                    time: 5000,
                }, NotificationType.Success);
                refetchItems === null || refetchItems === void 0 ? void 0 : refetchItems();
                onClose();
            }
            else {
                notify({
                    title: `An error occurred when trying to rename "${name}" schedule.`,
                }, NotificationType.Error);
            }
        }
        else {
            notify({
                title: 'An error occurred when trying to fetch current schedule.',
            }, NotificationType.Error);
        }
    }), [
        isEditMode,
        mode,
        props,
        readFlowScheduleResponse,
        notify,
        onClose,
        updateSchedule,
    ]);
    return (_jsx(EditModal, { isLoading: isLoading, name: isEditMode ? props.name : props.schedule.name, onClose: () => {
            onClose();
            analytics.businessHoursRenameScheduleFormCancelled();
        }, onSubmit: handleSubmit, title: "Rename schedule" }));
};
